import {
  OrderOptimizerListItem,
  OrderOptimizerListItemOrders,
  OrderOptimizerListItemRoute,
  OrderOptimizerListItemStatus,
} from "../../../../../common/services/order-optimizer/list/order-optimizer-list";
import {
  OrderOptimizerTaxiListingItem,
  OrderOptimizerTaxiListingItemOrder,
  OrderOptimizerTaxiListingItemRoute,
  OrderOptimizerTaxiListingItemStatus,
} from "./types/order-optimizer-taxi-listing-item";

const createListingItemOrder = (
  order: OrderOptimizerListItemOrders,
): OrderOptimizerTaxiListingItemOrder => {
  return {
    cargoCompany: order.cargoCompany,
    humanId: order.humanId,
    startTime: order.startTime,
    haltingTimeBefore: order.haltingTimeBefore,
  };
};

const createLIstingItemOrders = (
  orders: OrderOptimizerListItemOrders[],
): OrderOptimizerTaxiListingItemOrder[] => {
  return orders.map(createListingItemOrder);
};

const createListingItemRoute = (
  route: OrderOptimizerListItemRoute,
): OrderOptimizerTaxiListingItemRoute => {
  return {
    lat: route.lat,
    lon: route.lon,
    orderHumanId: route.orderHumanId,
  };
};

const createLIstingItemRoutes = (
  routes: OrderOptimizerListItemRoute[],
): OrderOptimizerTaxiListingItemRoute[] => {
  return routes.map(createListingItemRoute);
};

const createStatus = (
  status: OrderOptimizerListItemStatus,
): OrderOptimizerTaxiListingItemStatus => {
  switch (status) {
    case OrderOptimizerListItemStatus.INTERESTING:
      return OrderOptimizerTaxiListingItemStatus.INTERESTING;
    case OrderOptimizerListItemStatus.PENDING:
      return OrderOptimizerTaxiListingItemStatus.PENDING;
    case OrderOptimizerListItemStatus.REJECTED:
      return OrderOptimizerTaxiListingItemStatus.REJECTED;
  }
};

const createListingItem = (
  listItem: OrderOptimizerListItem,
): OrderOptimizerTaxiListingItem => {
  return {
    id: listItem.id,
    orders: createLIstingItemOrders(listItem.orders),
    reviewedAt: listItem.reviewedAt,
    reviewedBy: listItem.reviewedBy,
    route: createLIstingItemRoutes(listItem.route),
    score: listItem.score,
    status: createStatus(listItem.status),
  };
};

const createListingItems = (
  listItems: OrderOptimizerListItem[],
): OrderOptimizerTaxiListingItem[] => {
  return listItems.map(createListingItem);
};

const orderOptimizerTaxiListingItemFactory = {
  createListingItems,
};

export default orderOptimizerTaxiListingItemFactory;
